module.exports = __webpack_public_path__ + "static/SokLogo-4dc8f8b9c92ea1ac29029b9f3f28fc5d.png";